import React from 'react';
import PropTypes from 'prop-types';
import {
	ListItem,
	FormControlLabel,
	Grid,
	Radio,
	Typography,
} from '@material-ui/core';

import useStyles from './styles';

const InsuranceTypeListItem = ({ title, description, value, price }) => {
	const classes = useStyles();

	return (
		<ListItem>
			<FormControlLabel
				classes={{
					root: classes.root,
					label: classes.label,
				}}
				label={
					<Grid container spacing={1} justify="space-between" wrap="nowrap">
						<Grid item xs="auto">
							<Typography className={classes.title}>{title}</Typography>
							<Typography
								variant="h5"
								color="textSecondary"
								className={classes.description}
							>
								{description}
							</Typography>
						</Grid>
						{price && (
							<Grid item xs="auto">
								<Typography
									variant="h5"
									color="primary"
									noWrap
									className={classes.price}
								>
									+{price}{' '}
									<Typography variant="h6" component="span">
										SAR
									</Typography>
								</Typography>
							</Grid>
						)}
					</Grid>
				}
				control={<Radio color="primary" value={value} />}
			/>
		</ListItem>
	);
};

InsuranceTypeListItem.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	value: PropTypes.number,
	price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InsuranceTypeListItem;
